// extracted by mini-css-extract-plugin
export default {"status":"leads-tracking_status__kRAMI","active":"leads-tracking_active__pwGm4"};